import React from 'react';
import styled from '@emotion/styled';
import { Color } from '../../styles/Color';
import { gradients } from '../../styles';
import { useTranslation } from '../../i18n/translate/useTranslation';
import Responsive from '../../../../ui/utils/Responsive';

interface IPointProgressBarProps {
	progress: number;
	pending: number;
	remaining: number;
}
const PROGRESS_BAR_HEIGHT = '12px';
const PROGRESS_BAR_MOBILE_HEIGHT = '8px';
const PROGRESS_BAR_BORDER_RADIUS = '2px';

export const ProgressBar = ({
	progress,
	pending,
	remaining,
}: IPointProgressBarProps) => {
	const { t } = useTranslation();
	// total take 100% of the bar
	const total = progress + remaining;
	// percentage of the progress
	const progressPercent = (progress / total) * 100;
	// percentage of the remaining points
	const remainingPercent = (remaining / total) * 100;
	// percentage of pending
	const pendingPercent = (pending / total) * 100;

	return (
		<StyledPointsProgressBar
			data-testid="progress-bar"
			role="progressbar"
			aria-label={t('account_progress_bar_aria_label', {
				progress,
				pending,
			})}
		>
			{!!progress && (
				<StyledProgress data-testid="progress" value={progressPercent} />
			)}
			{!!pending && (
				<StyledPending
					data-testid="pending"
					value={
						pendingPercent > remainingPercent
							? remainingPercent
							: pendingPercent
					}
				/>
			)}
		</StyledPointsProgressBar>
	);
};

export const StyledPointsProgressBar = styled.div`
	display: flex;
	width: 100%;
	height: ${PROGRESS_BAR_HEIGHT};
	background-color: ${Color.Neutral90};
	border-radius: ${PROGRESS_BAR_BORDER_RADIUS};

	div {
		height: ${PROGRESS_BAR_HEIGHT};
		border-radius: ${PROGRESS_BAR_BORDER_RADIUS};
	}

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		height: ${PROGRESS_BAR_MOBILE_HEIGHT};
		div {
			height: ${PROGRESS_BAR_MOBILE_HEIGHT};
		}
	}
`;

const StyledProgress = styled.div<{ value: number }>`
	width: ${({ value }) => value}%;
	background-image: ${gradients['purple-blue'].gradient};
	background-color: ${gradients['purple-blue'].fallback};
`;

const StyledPending = styled.div<{ value: number }>`
	width: ${({ value }) => value}%;
	background-color: ${Color.Neutral70};
`;
